<template>
    <div class="pdl-10 pdr-10 mt-30">
        <div class="filters d-flex gap-4 flex-wrap flex-md-nowrap justify-content-between w-100 mb-30">
            <div class="d-flex flex-column gap-10 col-md-6 col-sm-12">
                <h2>Currently Listed on {{ userName }} Roster</h2>
                <!-- <h6>
                    Please review your listing for accuracy.
                    <a :href="`${baseUrl}/en/contact`" target="_blank">Contact Us.</a>
                </h6> -->
            </div>
            <TextInput type="text" name="mixed" placeholder="Search by NBF Participant ID, First or Last Name" :max=100
                v-model:modelValue="filter" customClass="search w-35 w-sm-100" />
        </div>
        <MessageCard :message="message" type="primary" iconClass="iatse-icon-alarm" classes="info_card__page"/>

        <LoaderComponent v-if="loading" />
        <div v-else>
            <button class="btn btn-primary mt-10 ms-auto plan-modal" @click="download" :disabled="downloading">
                <span v-if="downloading">Downloading PDF ...</span>
                <span v-else>Download PDF</span>
            </button>
            <table class="small striped toggle no-underline mt-30" id="table-roster">
                <thead class="large large_padding">
                    <tr>
                        <th>Last Name</th>
                        <th>First & Middle name</th>
                        <th>NBF Participant ID</th>
                        <th>Suffix</th>
                        <th>D.O.B</th>
                        <th>Gender</th>
                        <th>Marital Status</th>
                    </tr>
                </thead>
                <tbody v-if="data.length > 0 && !loading">
                    <tr v-for="person in data" :key="person.PersonID" class="large">
                        <td>
                            <a href="javascript;" class="plan-modal"
                                @click.prevent="openModal('local-member-profile', 'Member Profile', 'plan-profile plan-tables profile', null, { PersonID: person.PersonID })">
                                {{ person.LastName }}
                            </a>
                        </td>
                        <td>{{ person.FirstName }} <span v-if="person.MiddleName">, {{ person.MiddleName }}</span></td>
                        <td>{{ person.PersonID }}</td>
                        <td>{{ person.NameSuffix }}</td>
                        <td v-if="person.DateofBirth">{{ person.DateofBirth  }}</td>
                        <td v-else class="text-danger">Missing Info</td>
                        <td>{{ person.Gender }}</td>
                        <td>{{ person.MaritalStatus }}</td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr class="large">
                        <td colspan="8">
                            No results found.
                        </td>
                    </tr>
                </tbody>
            </table>
            <div id="print"></div>
            <PaginationComponent :paginator="paginator" @fetch-data="fetchPaginationData" />
        </div>
    </div>
</template>

<script lang="ts">
import { onMounted, ref, reactive, Ref, watch } from 'vue';
import { useAuthStore } from '@/stores/auth';
import { useModalStore } from '@/stores/modal';
import { usePrint } from '@/composable/usePrint';
import { Person } from '@/interfaces/local';
import { Paginator } from "@/interfaces/admin";

import PaginationComponent from '@components/utils/PaginationComponent.vue';
import TextInput from '@components/form/TextInput.vue';
import axios from 'axios';

export default {
    components: {
        PaginationComponent,
        TextInput
    },

    setup() {
        const loading = ref(true);
        const downloading = ref(false);
        const data: Ref<Person[] | []> = ref([]);
        const route = "api/local/roster";
        const userName = useAuthStore()?.userName;
        const modalStore = useModalStore();
        const paginator: Paginator = reactive({
            per_page: 0,
            total: 0,
            last_page: 0,
            current_page: 0,
        });
        const filter = ref('');
        const page = ref(1);
        const table = ref(null);
        const { printElementById } = usePrint();
        const message = "The Fund Office records indicate these members are part of your home Local. If any of this information appears to be incorrect please contact the Fund Office or email us at PSC@iatsenbf.org."

        const printList = printElementById('table-roster', 'Local Roster');

        const download = () => {
            const modalProps = {
                title: "Download Local Roster",
                content: {
                    type: "text",
                    value: 'Your report may take some time to download due to the large dataset. Please remain logged into the portal while the list is downloading.',
                    icon: "iatse-icon-user-verified",
                },
                confirmButtons: ["Cancel", " Ok"],
                onConfirm: async () => {
                    await downloadPDF();
                },
            }

            modalStore.openModal('success-modal', null, 'modal-success', null, modalProps);
        }

        async function downloadPDF() {
            downloading.value = true;

            try {
                const response = await axios.get(route, {
                    params: {
                        download_pdf: true,
                        Filters: { Search: filter.value }
                    },
                    responseType: 'blob' // Specify that the response will be a binary stream (PDF file)
                });

                const link = document.createElement('a');
                link.href = URL.createObjectURL(response.data);
                link.download = 'Currently Listed on ' + userName + 'Roster.pdf';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (error) {
                console.error('Error downloading PDF:', error);
            }

            downloading.value = false;
        }

        watch(filter, async () => {
            page.value = 1;
            await fetchData(true);
        }, { deep: true });

        const fetchData = async (isLoading: boolean) => {
            if (isLoading) {
                loading.value = true;
            }

            await axios.get(route, { params: { page: page.value, Filters: { Search: filter.value } } })
                .then(response => {
                    data.value = Object.values(response.data.Persons);
                    Object.assign(paginator, response.data.Paginator);
                    page.value = paginator.current_page;
                })
                .catch(error => {
                    console.error('There was an error!', error);
                })

            loading.value = false;
        };

        // Fetch Data For Selected Page
        const fetchPaginationData = (pageNumber: number) => {
            page.value = pageNumber;
            fetchData(false);
        };

        onMounted(async () => await fetchData(true));

        return {
            data,
            userName,
            loading,
            paginator,
            message,
            baseUrl: process.env.VUE_APP_PUBLIC_URL,
            filter,
            fetchPaginationData,
            openModal: modalStore.openModal,
            // print
            downloading,
            printList,
            download,
            downloadPDF
        };
    }
}
</script>
